import { TransactTypes } from '@/types/transact';
export const listOfCoins = [
    {
        name: 'USD Coin',
        symbol: 'USDC',
    },
    {
        name: 'Bitcoin',
        symbol: 'BTC',
    },
    {
        name: 'Ethereum',
        symbol: 'ETH',
    },
    {
        name: 'Tether TRC-20',
        symbol: 'USDT',
    },
];
export const networkTypes = {
    CELO: 'CELO',
    TRON: 'TRC20',
    ETHEREUM: 'ERC20',
    BTC: 'BTC',
    SOL: 'SOL',
    POLYGON: 'POLYGON',
    CARDANO: 'CARDANO',
    BASE: 'BASE',
    TON: 'TON',
    XRP: 'XRP',
    XLM: 'XLM',
};
export const networkCodes = Object.fromEntries(Object.entries(networkTypes).map(([key, value]) => [value, key]));
export const networkCoins = {
    USDT: [
        {
            networkType: networkTypes.TRON,
            standard: TransactTypes.Network.TRC20,
        },
        {
            networkType: networkTypes.CELO,
            standard: TransactTypes.Network.ERC20,
        },
        {
            networkType: networkTypes.TON,
            standard: TransactTypes.Network.TON,
        },
        {
            networkType: networkTypes.SOL,
            standard: TransactTypes.Network.SOL,
        },
        {
            networkType: networkTypes.POLYGON,
            standard: TransactTypes.Network.ERC20,
        },
    ],
    USDC: [
        {
            networkType: networkTypes.ETHEREUM,
            standard: TransactTypes.Network.ERC20,
        },
        {
            networkType: networkTypes.CELO,
            standard: TransactTypes.Network.ERC20,
        },
        {
            networkType: networkTypes.BASE,
            standard: TransactTypes.Network.ERC20,
        },
        {
            networkType: networkTypes.SOL,
            standard: TransactTypes.Network.SOL,
        },
        {
            networkType: networkTypes.POLYGON,
            standard: TransactTypes.Network.ERC20,
        },
        {
            networkType: networkTypes.XLM,
            standard: TransactTypes.Network.XLM,
        },
    ],
    CUSD: [
        {
            networkType: networkTypes.CELO,
            standard: TransactTypes.Network.ERC20,
        },
    ],
    BTC: [
        {
            networkType: networkTypes.BTC,
            standard: TransactTypes.Network.BTC,
        },
    ],
    ETH: [
        {
            networkType: networkTypes.ETHEREUM,
            standard: TransactTypes.Network.ERC20,
        },
    ],
    SOL: [
        {
            networkType: networkTypes.SOL,
            standard: TransactTypes.Network.SOL,
        },
    ],
    XAUT: [
        {
            networkType: networkTypes.TRON,
            standard: TransactTypes.Network.TRC20,
        },
        {
            networkType: networkTypes.ETHEREUM,
            standard: TransactTypes.Network.ERC20,
        },
    ],
    PYUSD: [
        {
            networkType: networkTypes.ETHEREUM,
            standard: TransactTypes.Network.ERC20,
        },
    ],
    ADA: [
        {
            networkType: networkTypes.CARDANO,
            standard: TransactTypes.Network.CARDANO,
        },
    ],
    MATIC: [
        {
            networkType: networkTypes.POLYGON,
            standard: TransactTypes.Network.POLYGON,
        },
        {
            networkType: networkTypes.ETHEREUM,
            standard: TransactTypes.Network.ERC20,
        },
    ],
    TON: [
        {
            networkType: networkTypes.TON,
            standard: TransactTypes.Network.TON,
        },
    ],
    RLUSD: [
        {
            networkType: networkTypes.XRP,
            standard: TransactTypes.Network.XRP,
        },
    ],
};
export function capitalizeFirstLetter(string, lower = false) {
    return (string.charAt(0).toUpperCase() +
        string.slice(1)[lower ? 'toLocaleLowerCase' : 'toString']());
}
export function formatString(input) {
    return input
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
